import { render, staticRenderFns } from "./BoxTile.vue?vue&type=template&id=0591c7ca&"
import script from "./BoxTile.vue?vue&type=script&lang=ts&"
export * from "./BoxTile.vue?vue&type=script&lang=ts&"
import style0 from "./BoxTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports